import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {AppComponent} from '../app.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
const incr = 7;

@Component({
  selector: 'app-daas-creator',
  templateUrl: './daas-creator.component.html',
  styleUrls: ['./daas-creator.component.scss']
})
export class DaasCreatorComponent implements OnInit {


  @ViewChild('myForm', {static: false}) public MyForm: NgForm;
  @ViewChild('myForm1', {static: false}) public MyForm1: NgForm;
  @ViewChild('myForm2', {static: false}) public MyForm2: NgForm;

  constructor(private confPost: ConfService, private _service: ConnecttocrudService, private appComp: AppComponent,
              public platform: LeftpanelComponent) { }

  APILoadingdB = false;
  buttonClickdB = false;
  importDataDB = true;
  listofTables: any;
  listofViews: any;
  listofProcedures: any;
  listofIndexes: any;
  useReferentialKeys: boolean;
  databaseName: string;
  targetDatabase: any;
  dberror = true;
  listofTable = ['All'];
  entityTypes = [];
  databases: any;
  datatypes: any;
  listOfObjects: any;


  databaseObjectTypes: any;
  selectedDatabaseObjectTypes: any;
  databaseObjectTypeFilter: any;
  selectedDatatypeFilter: any;
  targetDatabaseType: any;
  transformOptionSelected: any;
  transformOptions = [
    {'name': 'Generate APIs Only - No Data Migration',
      'value': 'apionly'},
    {'name': 'Migrate Data Only - No API Generation',
      'value': 'dataonly'},
    {'name': 'Migrate Data & Generate APIs',
      'value': 'apiwithdata'}
  ];

  referentialKeyOptions = [
    {'value': 'embed',
      'display_name': 'Embed child data with parent entity'},
    {'value': 'reference',
      'display_name': 'Seperate data and create reference'}
  ];
  referentialKeyOptionSelected = 'reference';

  dataMigration = false;
  deploymentPlan: any;
  apiExecutorPlans: any;
  entityPlans: any;
  dataMigrationPlans: any;
  showNextPanel = false;
  showStatusPanel = false;

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');
  dataTypeFilter = [];
  progress = 0;
  progressMessage: string;

  showDeploymentPlanFlag = true;
  cascadeOnDelete = true;
  cascadeOnUpdate = true;

  listOfTables: any;
  listOfViews: any;
  listOfProcedures: any;
  listOfIndexes: any;

  loading = false;
  loading1 = false;
  buildDeploymentRetries = 0;

  filterDatabaseObjectTypes(val) {
    this.getDatabaseTypeForDatabaseName(val);
    this.databaseObjectTypeFilter = [];
    this.databaseObjectTypes.filter(items => {
      if (items.database_type === this.selectedDatatypeFilter ) {
        this.databaseObjectTypeFilter.push(items.database_object_types);
      }
    });
    // this.filteredDatabaseObjects = this.databaseObjectTypeFilter[0].database_object_types;
  }
  // getDatabaseObjectTypesForDatabaseName(val) {
  //   this.databases.filter(items => {
  //     if (items.database_name === val) {
  //       this.selectedDatatypeFilter = items.database_type;
  //     }
  //   });
  // }

  getDatabaseTypeForDatabaseName(val) {
    this.databases.filter(items => {
      if (items.database_name === val) {
        this.selectedDatatypeFilter = items.database_type;
      }
    });
  }

  buildDeploymentPlanForTransformation(requestModel) {
    this.buildDeploymentRetries += 1;
    if (this.buildDeploymentRetries <= 5) {
      this.confPost.buildDeploymentPlanForDatabaseTransformation(localStorage.getItem('partner'), localStorage.getItem('account'), requestModel).subscribe(data => {
        if (data && data['body']) {
          this.deploymentPlan = data['body'];
          if (this.deploymentPlan) {
            this.apiExecutorPlans = this.deploymentPlan.executorModelDeploymentPlans;
            this.entityPlans = this.deploymentPlan.entityDeploymentPlans;
            this.dataMigrationPlans = this.deploymentPlan.dataMigrationPlans;
            // this.showNextPanel = true;
            // this.loading1 = false;
          }
        }
      }, error => {
        setTimeout(() => {
          this.buildDeploymentPlanForTransformation(requestModel);
        }, 6000);
      });
    } else {
      this.loading1 = false;
      this.buildDeploymentRetries = 0;
      this.platform.openSnackBar('Oops!!! Something went wrong. Please try again after sometime.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  buildDeploymentPlanForDatabaseTransformation() {
    this.loading1 = true;
    if (this.MyForm2.valid) {
      if (this.dataMigration) {
        if (this.MyForm1.valid) {
          this.showDeploymentPlanFlag = false;
          const dbObjectsSelected = {
            'table': this.listofTables,
            'view': this.listofViews,
            'procedure': this.listofProcedures,
            'index': this.listofIndexes
          }
          const requestModel = {
            'sourceDatabaseName': this.databaseName,
            'types': this.selectedDatabaseObjectTypes,
            'databaseObjects': this.listofTables,
            'transformOption': this.transformOptionSelected,
            'targetDatabaseName': (this.transformOptionSelected !== 'apionly' ? this.targetDatabase : this.databaseName),
            'useReferentialKey': this.useReferentialKeys,
            'referentialKeyOption': this.referentialKeyOptionSelected,
            'cascadeOnDelete': this.cascadeOnDelete,
            'cascadeOnUpdate': this.cascadeOnUpdate
          };
          this.buildDeploymentPlanForTransformation(requestModel);
        } else {
          alert('Select atleast one Target Database');
          this.loading1 = false;
        }
      } else {
        this.showDeploymentPlanFlag = false;
        const dbObjectsSelected = {
          'table': this.listofTables,
          'view': this.listofViews,
          'procedure': this.listofProcedures,
          'index': this.listofIndexes
        }
        const requestModel = {
          'sourceDatabaseName': this.databaseName,
          'types': this.selectedDatabaseObjectTypes,
          'databaseObjects': this.listofTables,
          'transformOption': this.transformOptionSelected,
          'targetDatabaseName': (this.transformOptionSelected !== 'apionly' ? this.targetDatabase : this.databaseName),
          'useReferentialKey': this.useReferentialKeys,
          'referentialKeyOption': this.referentialKeyOptionSelected,
          'cascadeOnDelete': this.cascadeOnDelete,
          'cascadeOnUpdate': this.cascadeOnUpdate
        };
        this.buildDeploymentPlanForTransformation(requestModel);
      }
    } else {
      alert('Select atleast one item in list of objects');
      this.loading1 = false;
    }
  }

  manageProgress() {
    if (this.progress >= 100) {
      this.showNextPanel = true;
      this.showStatusPanel = false;
    } else {
      this.progress = this.progress + incr;
    }
    if (this.progress <= 35) {
      this.progressMessage = 'Setting Up API';
    } else if (this.progress > 35 && this.progress <= 70) {
      this.progressMessage = 'Setting Up Database';
      /*} else if (this.progress > 70 && this.progress <= 98) {
          this.progressMessage = 'Creating dedicated File storage for your account';*/
    } else if (this.progress > 70) {
      this.progressMessage = 'Deploying into Cloud';
    }
  }

  loadDaas() {
    // console.log('listofTables: ' + JSON.stringify(this.listofTables));
    const requestModel = {
      'sourceDatabaseName': this.databaseName,
      'types': this.selectedDatabaseObjectTypes,
      'databaseObjects': this.listofTables,
      'transformOption': 'apionly',
      'targetDatabaseName': (this.transformOptionSelected !== 'apionly' ? this.targetDatabase : this.databaseName),
      'useReferentialKey': true,
      'referentialKeyOption': this.referentialKeyOptionSelected,
      'cascadeOnDelete': this.cascadeOnDelete,
      'cascadeOnUpdate': this.cascadeOnUpdate
    };
    this.buildDeploymentPlanForTransformation(requestModel);
    // console.log('Deployment Plan : ' + JSON.stringify(this.entityPlans));
  }

  async ngOnInit() {
    this.appComp.currentPageTitle = 'Generate API from Database Objects';
    if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
      this.datatypes = this.platform.datatypes;
    } else {
      await this.platform.getDataTypesForPartnerAccount();
      this.datatypes = this.platform.datatypes;
    }

    if (this.platform.databases !== null && this.platform.databases !== undefined) {
      this.databases = this.platform.databases;
    } else {
      await this.platform.getDatabasesForPartnerAccount();
      this.databases = this.platform.databases;
    }
    this.dataTypeFilter = [];
    this.datatypes.filter(items => {
      if (items.database_type === this.selectedDatatypeFilter ) {
        this.dataTypeFilter.push(items);
      }
    });
    if (this.selectedDatatypeFilter === 'mongodb') {
      this.entityTypes.forEach(entityType => {
        const newType = {'database_type': 'mongodb',
          'data_types': [
            {'type': entityType,
              'default_length': '',
              'min_length': '',
              'max_length': ''
            }]};
        this.dataTypeFilter.push(newType);
      });
    }
    if (this.databaseObjectTypes === null || this.databaseObjectTypes === undefined) {
      this.confPost.getDatabaseObjectTypes().subscribe(data => {
        this.databaseObjectTypes = data;
      });
    }

    // this.confPost.getTablesFromDatabaseForPartner(localStorage.getItem('partner'), this.databaseName).subscribe(data => {
    //   this.listOfObjects = data;
    // });
  }
  updateObjects() {
    this.filterDatabaseObjectTypes(this.databaseName);
  }


  listObjects() {
    this.loading = true;
    if (this.MyForm.valid) {
      if (this.databaseName && this.selectedDatabaseObjectTypes) {
        // this.confPost.getDatabaseObjectsFromDatabaseForPartner(localStorage.getItem('partner'), this.databaseName, this.selectedDatabaseObjectTypes).subscribe(data => {
        //   this.listOfObjects = data;
        // });

        this.confPost.getAllDatabaseObjectsFromDatabaseForPartner(localStorage.getItem('partner'), this.databaseName, this.selectedDatabaseObjectTypes).subscribe(data => {
          this.loading = false;
          this.listOfObjects = data;
          this.listOfTables = this.listOfObjects.table;
          this.listOfViews = this.listOfObjects.view;
          this.listOfProcedures = this.listOfObjects.procedure;
          this.listOfIndexes = this.listOfObjects.index;
        }, error => {
          this.loading = false;
          this.platform.openSnackBar('Unable to connect to the database. Please check the connection details of database.', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      }
    } else {
      alert('Select atleast one database object type');
      this.loading = false;
    }
  }

  updateTransformOptions(){
    if (this.transformOptionSelected === 'apionly') {
      this.dataMigration = false;
      this.targetDatabase = null;
    } else {
      this.dataMigration = true;
    }
  }

  validateDatabaseSelection() {
    this.databases.forEach(database => {
      if (database.database_name === this.targetDatabase) {
        this.targetDatabaseType = database.database_type;
      }
    });

    if (this.targetDatabase === this.databaseName) {
      this.platform.openSnackBar('Source and Target Databases can not be same.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  createAPIByDB() {
    this.buttonClickdB = true;
    this.dberror = false;
    const crudAPI = {
      'database_name': this.databaseName,
      'listOfTables': this.listofTables,
      'useReferentialKeys': this.useReferentialKeys,
      'targetDatabase': (this.targetDatabase == null ? 'default' : this.targetDatabase),
      'importData': this.importDataDB
    };

    this.confPost.createAPIFromDB(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
      this.platform.openSnackBar('API Created successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.APILoadingdB = true;

    }, error => {
      this.dberror = true;
      this.APILoadingdB = true;
      this.platform.openSnackBar(error.error.message, 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  createAPIByDatabaseObjects() {
    this.buttonClickdB = true;
    this.APILoadingdB = false;
    this.dberror = false;
    // this.statusTable = [];
    this.listofTables.forEach(table => {
      const crudAPI = {
        'database_name': this.databaseName,
        'tableName': table,
        'useReferentialKeys': this.useReferentialKeys,
        'targetDatabase': (this.targetDatabase == null ? 'default' : this.targetDatabase),
        'importData': this.importDataDB
      };
      this.createApiForTable(crudAPI);
    });
    this.buttonClickdB = false;
    this.APILoadingdB = true;
  }

  async createApiForTable(crudAPI) {
    await this.confPost.createAPIByDBObjects(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
      const stat = {
        'tableName' : crudAPI.tableName,
        'apistatus' : 'Success',
        'databasestatus' : 'Success',
        'deploystatus' : 'Success',
        'gatewaystatus' : 'Success'
      }
    }, error => {
      this.dberror = true;
      const stat = {
        'tableName' : crudAPI.tableName,
        'apistatus' : 'Failed',
        'databasestatus' : 'Failed',
        'deploystatus' : 'Failed',
        'gatewaystatus' : 'Failed'
      }
    });
  }
}
